import Link from "next/link";
import {SITE_URL} from "common/const";
import styles from "components/cards/search/BrandSearchItemCard.module.scss";
import classNames from "classnames";
import Image from "next/image";
import utilStyles from "styles/utils.module.scss";
import ArrowRightIcon from "images/icons/arrow_right_black.svg";
import TruncateMarkup from "react-truncate-markup";
import {useMemo} from "react";
import {highlightMatchedText} from "common/utils";
import parse from "html-react-parser";
import useTranslation from "next-translate/useTranslation";


const BrandSearchItemCard = (props) => {
    const {brand, highlightKeyword} = props;
    const {t} = useTranslation('sections-search-BrandSearchItemCard');

    const name = brand.name;
    const profileImage = brand.logo_image_with_background_url || brand.logo_image_url;

    const onClick = props.onClick || (() => {
    });

    const brandKeywords = useMemo(() => {
        let keywords = brand.keywords && brand.keywords.length > 0 ? brand.keywords.join(',') : null;
        if (keywords && highlightKeyword) {
            keywords = parse(highlightMatchedText(keywords, highlightKeyword));
        }
        return keywords
    }, [brand]);

    return (
        <Link
            href={`${SITE_URL}/store/brands/${brand.id}`}>
            <a className={styles.brandCreatorCardContainer} onClick={onClick}>
                <div className={classNames(styles.brandCreatorProfileImage)}>
                    <Image unoptimized src={profileImage} layout="fill" objectFit="cover"/>
                </div>
                <div className={utilStyles.fullFlex}>
                    <TruncateMarkup lines={1} ellipsis={<span>...</span>}>
                        <span className={styles.brandCreatorCardTitle}>
                            {
                                name.split(/(_+)/).map((e, idx) => {
                                    if (e.includes('_')) {
                                        return <span style={{
                                            fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu,\n' +
                                                '  Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif',
                                        }} key={idx}>{e}</span>
                                    } else {
                                        return e;
                                    }
                                })
                            }
                        </span>
                    </TruncateMarkup>
                    <span className={styles.brandCreatorCardDescription}>{brandKeywords || t('BrandSearchItemCard.brandPage')}</span>
                </div>
                <ArrowRightIcon viewBox="0 0 12 12" width={20} height={20}/>
            </a>
        </Link>
    )
};

export default BrandSearchItemCard;
